import React from 'react'
import { connect } from 'react-redux'
import { Link, Navigate } from 'react-router-dom'

import { getPersonsCount, asyncDeletePerson } from '../ducks/persons.js'
import { apiEndpoint } from '../ducks/rails.js'
import { resetWizardState } from '../ducks/wizard.js'
import { Panel, PanelSidebar, PanelRightColumn, PanelBody, PanelControls } from '../panel'
import BootstrapModal from '../../../shared/components/bootstrap_modal.jsx'

import PersonsCard from './persons_card.jsx'

class PersonsIndex extends React.Component {
  constructor(props) {
    super(props)

    this.state = { confirmingDelete: false, deletingId: null }
  }

  componentWillUnmount() {
    this.props.resetWizardState()
  }

  handleDeleteClicked = (personId) => (event) => {
    this.setState({ confirmingDelete: true, deletingId: personId })
  }

  handleDelete = () => {
    return this.props.asyncDeletePerson(this.state.deletingId, this.props.personsCount)
  }

  handleModalClosed = () => {
    this.setState({ confirmingDelete: false, deletingId: null })
  }

  render() {
    // we have a problem where, when/if the last person card is deleted we'll redirect before
    // the confirmation modal hides. that unmounts this and that before we have a chance to
    // cleanup state or the dom. this is a sucky pattern, but the alternatives are to move the
    // bootstrap modal up in the heiarchy, or track whether this and the modal are mounted or not.
    //
    if (this.props.personsCount === 0 && !this.state.confirmingDelete) {
      return <Navigate to="/persons/new" />
    }

    return (
      <Panel>
        <PanelSidebar />

        <PanelRightColumn>
          <PanelBody>
            <div className="row">
              <div className="col-xs-12">
                <h4>Injury or Illness Report</h4>

                <p>
                  Below, you can add, edit, or delete injury records from this report or add new ones.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12">
                <p>
                  <Link to="/persons/new">
                    <button type="button" className="btn btn-success btn-with-icon plus">
                      Add New
                    </button>
                  </Link>
                </p>
              </div>
            </div>

            <div className="row">
              {
                Object.entries(this.props.persons).map(([_, person]) => (
                  <div key={ person.id } className="col-xs-12">
                    <PersonsCard id={ person.id }
                                 handleDeleteClicked={ this.handleDeleteClicked(person.id) }
                                 person={ person } />
                  </div>
                ))
              }
            </div>

            {
              this.state.confirmingDelete &&
                <BootstrapModal title="Confirm Deletion"
                                handleHide={ this.handleModalClosed }
                                buttons={[
                                  { className: "btn btn-link", dismiss: true, name: "Cancel" },
                                  {
                                    className: "btn btn-default btn-danger",
                                    onClick: this.handleDelete,
                                    loading: this.props.deletingPerson,
                                    name: "Delete"
                                  }
                                ]}>

                  <p>{ 'Are you sure you want to delete this person?' }</p>
                </BootstrapModal>
            }
          </PanelBody>

          <PanelControls>
            <Link to="/contact_details">
              <button type="button"
                      className="btn btn-link">
                Back
              </button>
            </Link>


            <Link to="/vehicles">
              <button type="button"
                      className="btn btn-success">

                Save & Continue
              </button>
            </Link>
          </PanelControls>
        </PanelRightColumn>
      </Panel>
    )
  }
}

PersonsIndex = connect(
  (state, props) => ({
    personsCount:   getPersonsCount(state.persons),
    persons:        state.persons,
    deletingPerson: state.wizard.updating,
    apiEndpoint:    apiEndpoint(state.rails, "incident_report")
  }),
  null,
  ({ apiEndpoint, ...stateProps }, { dispatch }, props) => ({
    ...stateProps,
    ...props,

    asyncDeletePerson: (id, personsCount) => {
      return asyncDeletePerson(apiEndpoint.path, id, personsCount)(dispatch)
    },

    resetWizardState: () => { dispatch(resetWizardState()) }
  })
)(PersonsIndex);

export default PersonsIndex
